import Vue from "vue"
import Tinymce from "./Tinymce/Tinymce.vue"
import imgUpload from "./img-upload.vue"
import fileUpload from "./file-upload.vue"
import loginAndRegister from "./loginAndRegister.vue"
Vue.component("login-and-register", loginAndRegister)

Vue.component("Tinymce", Tinymce)
Vue.component("img-upload", imgUpload)
Vue.component("file-upload", fileUpload)



// WEBPACK FOOTER //
// ./src/components/index.js